<div class="catalogs-container">
  <div class="catalogs-header">
    <h2 class="left-title">{{ 'catalogs_header.title' | translate }}</h2>
    <span class="right-title">
      {{ 'catalogs_header.available' | translate }}: {{ catalogs?.length || 0 }}
    </span>
  </div>
  <div class="filters">
    <div class="search-container">
      <ui-form-field [formControl]="searchControl" [placeholder]="'explore_catalogs.search_catalogs' | translate"
        [type]="'text'" suffixIcon="search-cc" (focus)="searchControlFocused = true">
      </ui-form-field>
    </div>

    <!-- Boutons de vue -->
    <div class="view-as" [class.search-container-focused]="searchControlFocused">
      <span class="view-as-label">{{ 'common.view_as' | translate }}:</span>
      <ui-button [class.active-view]="isCardView" type="view-as-btn" icon="grid-cc" iconSize="large"
        (click)="isCardView = true"></ui-button>
      <ui-button [class.active-view]="!isCardView" type="view-as-btn" icon="list-cc" iconSize="large"
        (click)="isCardView = false"></ui-button>
    </div>
  </div>
  <div class="catalogs-listing">
    <div [class.catalogs-table]="!isCardView" [class.catalogs-grid]="isCardView">
      <!-- Catalogs table header when in list view -->
      <div *ngIf="!isCardView" class="catalog-row header" [class.scroll-offset]="isScrollable">
        <div>{{ 'explore_catalogs.image' | translate }}</div>
        <div>{{ 'explore_catalogs.catalog_name' | translate }}</div>
        <div class="optional-field">{{ 'explore_catalogs.tags' | translate }}</div>
        <div class="stacked-header">
          {{ 'explore_catalogs.total_skus' | translate }}
          <span class="secondary-text">{{ 'explore_catalogs.total_quantity' | translate }}</span>
        </div>
        <div class="optional-field">{{ 'explore_catalogs.creation_date' | translate }}</div>
        <div>{{ 'explore_catalogs.expiry_date' | translate }}</div>
        <div class="optional-field">{{ 'explore_catalogs.status' | translate }}</div>
      </div>
      <div class="catalogs-viewport" [class.grid-view]="isCardView && !isLoading && catalogs.length">
        <ng-container *ngIf="!isLoading">

          <ng-container *ngFor="let catalog of catalogs">
            <!-- Catalog row in list view -->
            <ng-container *ngIf="!isCardView; else cardView">
              <div class="catalog-row data" (click)="goTo(catalog)">
                <!-- Image -->
                <div class="image-cell">
                  <img *ngIf="!failedImages.has(catalog.id!)" [src]="
                      catalog.image ? API_URL + '/' + catalog.image : 'assets/images/no-img.svg'
                    " [alt]="catalog.name" class="catalog-image" (error)="onImageError(catalog.id!)" />
                  <div *ngIf="failedImages.has(catalog.id!)" class="catalog-image-placeholder">
                    <mat-icon>image</mat-icon>
                  </div>
                </div>
                <!-- Name -->
                <div [title]="catalog.name">
                  {{ displayText(catalog.name, 20) }}
                </div>
                <div class="optional-field">
                  <div class="tags" (click)="$event.stopPropagation()">
                    <div *ngFor="let item of getCatalogTags(catalog)" class="action-tag" [class]="item.tag + '--tag'">
                      {{ item.label }}
                    </div>
                  </div>
                </div>
                <!-- Inventory -->
                <div>
                  <div>{{ catalog.nbr_products }}</div>
                  <div class="secondary-text-bold" *ngIf="catalog.show_stock">
                    {{ catalog.stock_quantity || 0 }}
                  </div>
                </div>
                <!-- Creation date -->
                <div class="optional-field">
                  {{ catalog.create_date ? (catalog.create_date | date: DATE_FORMAT) : '--' }}
                </div>
                <!-- Expiry date -->
                <div>
                  {{ catalog.end_date ? (catalog.end_date | date: DATE_FORMAT) : '--' }}
                </div>
                <!-- Status -->
                <div class="optional-field">
                  <div>
                    <span [class]="'active--tag'">{{ 'explore_catalogs.active' | translate }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- Catalog card in grid view -->
            <ng-template #cardView>
              <div class="catalog-card" (click)="goTo(catalog)">
                <img *ngIf="!failedImages.has(catalog.id!)"
                  [src]="catalog.image ? API_URL + '/' + catalog.image : 'assets/images/no-img.svg'"
                  [alt]="catalog.name" class="catalog-image" (error)="onImageError(catalog.id!)" />
                <div *ngIf="failedImages.has(catalog.id!)" class="catalog-image-placeholder">
                  <mat-icon>image</mat-icon>
                </div>
                <div class="tags" (click)="$event.stopPropagation()">
                  <div *ngFor="let item of getCatalogTags(catalog)" class="action-tag" [class]="item.tag + '--tag'">
                    {{ item.label }}
                  </div>
                </div>
                <div class="title">
                  {{ displayText(catalog.name, 20) }}
                </div>
                <div class="desc">
                  {{ displayText(catalog.description, 90) }}
                </div>
                <hr class="separtor" style="margin-top: auto" />
                <div class="quantity">
                  <span>{{ catalog.nbr_products }} SKUs</span>
                  <span *ngIf="catalog.show_stock">
                    {{ catalog.stock_quantity }} {{ 'common.units' | translate }}
                  </span>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <!-- Load more button -->
          <div class="load-more" *ngIf="catalogs.length > 0 && canLoadMore && !isLoadingMore"
            [class.grid-view]="isCardView && !isSkeletonLoaderActive">
            <ui-button type="transparent" [label]="'common.load_more' | translate" (click)="loadMore()"
              class="load-more-button" [fullWidth]="true"></ui-button>
          </div>
          <!-- No data container -->
          <div class="no-data" *ngIf="catalogs.length === 0">
            <ui-svg-icon svgIcon="empty-inbox"></ui-svg-icon>
            <p>{{ 'common.no_data' | translate }}</p>
          </div>
        </ng-container>
        <!-- Loading Skeleton -->
        <ng-container *ngIf="isSkeletonLoaderActive">
          <!-- <ngx-skeleton-loader
            *ngIf="!isCardView"
            [count]="10"
            appearance=""
            [theme]="{
              height: '50px',
              'border-radius': '12px',
              margin: '2px'
            }"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            *ngIf="isCardView"
            [count]="isLoadingMore ? 1 : 10"
            appearance=""
            [theme]="{
              width: '340px',
              height: '525px',
              'border-radius': '12px',
              'margin-right': '10px'
            }"
          ></ngx-skeleton-loader> -->
        </ng-container>
      </div>
      <div class="go-to-top" *ngIf="showScrollTop">
        <ui-button type="transparent" icon="arrow-up" (click)="scrollToTop()"></ui-button>
      </div>
    </div>
  </div>
</div>